import React from 'react'
import {Col, Container, Row} from 'styled-bootstrap-grid'
import {PageContainer} from 'src/components/layout'
import type {GetStaticProps} from 'next'
import {makeSubscriptionProps} from 'src/api/datocms/utils'
import {pageQuery} from 'src/api/datocms/queries'
import styled from 'styled-components'
import {H1} from 'src/components/typography'
import {EmploymentForm} from 'src/components/pageForms/employment'
import {DEFAULT_REVALIDATE_TIME} from 'src/const'

export const getStaticProps: GetStaticProps = async ({preview = false}) => ({
  props: {
    pageSubscription: await makeSubscriptionProps(preview, pageQuery),
  },
  revalidate: DEFAULT_REVALIDATE_TIME,
})

const Wrapper = styled.div`
  max-width: 800px;
  margin-bottom: 24px;
`

export default function Reikningsvidskipti(): JSX.Element {
  return (
    <PageContainer title="Starfsumsókn | Rekstrarvörur">
      <Container>
        <Wrapper>
          <Row>
            <Col>
              <H1 withGutter>Sækja um starf</H1>
            </Col>
          </Row>
        </Wrapper>
        <EmploymentForm />
      </Container>
    </PageContainer>
  )
}
